import TradeArrow from '../../src/legacy/TradeArrow';
export default TradeArrow;
